{
  "common": {
    "memberCenter": "會員中心",
    "points": "積分",
    "level": "等級",
    "coupons": "優惠券",
    "checkin": "簽到",
    "history": "歷史記錄",
    "balance": "餘額",
    "expire": "過期",
    "confirm": "確認",
    "cancel": "取消",
    "loading": "載入中...",
    "noData": "暫無資料",
    "retry": "重試",
    "success": "成功",
    "failed": "失敗"
  },
  "points": {
    "earn": "獲得 {amount} 積分",
    "spend": "消費 {amount} 積分",
    "balance": "目前餘額：{amount} 積分",
    "expired": "{amount} 積分已過期",
    "estimated": "預估中（待確認入帳）"
  },
  "level": {
    "current": "目前等級：{name}",
    "nextLevel": "下一等級：{name}",
    "progress": "距下一等級還需 {current}/{target}",
    "upgraded": "恭喜！已升級至 {name}"
  },
  "coupon": {
    "claim": "領取",
    "claimed": "已領取",
    "expired": "已過期",
    "used": "已使用",
    "validUntil": "有效期至 {date}",
    "threshold": {
      "none": "無門檻",
      "min": "滿 {amount} 可用"
    }
  },
  "checkin": {
    "today": "今日簽到",
    "done": "已簽到",
    "streak": "連續簽到 {days} 天",
    "reward": "+{amount} 積分"
  },
  "errors": {
    "network": "網路錯誤，請重試",
    "unauthorized": "請先登入",
    "serverError": "伺服器異常，請稍後再試",
    "timeout": "請求逾時"
  },
  "ui": {
    "memberCenter": {
      "loading": "載入中...",
      "avatarAlt": "會員頭像",
      "pointsBalance": "我的積分",
      "menuLabel": "會員功能導覽",
      "menu": {
        "pointsDetail": "積分明細",
        "levelDetail": "等級權益",
        "coupons": "我的優惠券",
        "referral": "邀請好友",
        "checkin": "每日簽到",
        "orders": "我的訂單",
        "exchange": "積分商城",
        "address": "地址管理",
        "profile": "個人資料",
        "account": "帳號設定"
      }
    },
    "pointsDetail": {
      "title": "積分明細",
      "empty": "暫無積分流水",
      "loading": "載入中...",
      "noMore": "已經到底囉",
      "listLabel": "積分流水列表",
      "status": {
        "pending": "待確認",
        "active": "已生效",
        "used": "已使用",
        "expired": "已過期"
      }
    },
    "levelProgress": {
      "loading": "載入中...",
      "maxLevel": "已是最高等級",
      "progressLabel": "等級進度",
      "noBenefits": "暫無權益",
      "nextLevel": "下一等級：{name}",
      "benefitsTitle": "我的權益"
    },
    "couponList": {
      "title": "我的優惠券",
      "tabsLabel": "優惠券分類",
      "listLabel": "優惠券列表",
      "empty": "暫無優惠券",
      "freeShipping": "免運",
      "giftValue": "贈品",
      "discountValue": "{value} 折",
      "type": {
        "discount": "折扣券",
        "cash": "現金券",
        "shipping": "運費券",
        "gift": "贈品券"
      },
      "tab": {
        "claimable": "領券",
        "unused": "未使用",
        "used": "已使用",
        "expired": "已過期"
      },
      "loadingClaimable": "載入中...",
      "noClaimable": "暫無可領取優惠券",
      "claiming": "領取中...",
      "claim": "領取",
      "stockInfo": "剩餘 {remaining} 張",
      "stockUnlimited": "不限量",
      "minOrder": "滿 {amount} 可用"
    },
    "referralShare": {
      "loading": "載入中...",
      "title": "邀請好友",
      "shareTitle": "邀請好友贏積分",
      "shareText": "快來加入會員，註冊即送好禮！",
      "invitedCount": "已邀請",
      "rewardPoints": "已獲積分",
      "codeLabel": "我的邀請碼",
      "linkLabel": "邀請連結",
      "copy": "複製",
      "copyCode": "複製邀請碼",
      "share": "立即分享",
      "rewardHint": "每邀請一位好友獎勵 {points} 積分",
      "tabShare": "邀請",
      "tabRecords": "邀請記錄",
      "loadingRecords": "載入記錄中...",
      "noRecords": "暫無邀請記錄",
      "anonymousUser": "匿名用戶",
      "prevPage": "上一頁",
      "nextPage": "下一頁",
      "recordsLabel": "邀請記錄列表",
      "status": {
        "registered": "已註冊",
        "first_order": "已首單",
        "rewarded": "已發獎"
      }
    },
    "checkinCalendar": {
      "loading": "載入中...",
      "checking": "簽到中...",
      "checkin": "立即簽到",
      "alreadyChecked": "今日已簽到",
      "day": "{count} 天",
      "title": "每日簽到",
      "streak": "連續簽到 {days} 天",
      "calendarLabel": "簽到日曆",
      "rewardsTitle": "連續簽到獎勵",
      "rewardsLabel": "簽到獎勵列表",
      "prevMonth": "上個月",
      "nextMonth": "下個月",
      "monthDays": "本月簽到 {count} 天",
      "monthPoints": "本月積分",
      "weekday": {
        "sun": "日",
        "mon": "一",
        "tue": "二",
        "wed": "三",
        "thu": "四",
        "fri": "五",
        "sat": "六"
      }
    },
    "orderList": {
      "loading": "載入訂單中...",
      "title": "訂單記錄",
      "noOrders": "暫無訂單記錄",
      "listLabel": "訂單記錄列表",
      "prevPage": "上一頁",
      "nextPage": "下一頁",
      "typePoints": "積分",
      "typeGrowth": "成長值",
      "bizType": {
        "Order_Pay": "訂單支付",
        "Order_Refund": "訂單退款"
      },
      "status": {
        "pending": "待確認",
        "active": "已到帳",
        "invalid": "已失效",
        "used": "已使用",
        "expired": "已過期"
      }
    },
    "addressManager": {
      "title": "我的地址",
      "add": "新增地址",
      "empty": "暫無收貨地址",
      "default": "預設",
      "setDefault": "設為預設",
      "edit": "編輯",
      "delete": "刪除"
    },
    "accountSettings": {
      "title": "帳號設定",
      "dataExport": {
        "title": "匯出我的資料",
        "desc": "下載您所有個人資料的副本",
        "button": "申請匯出",
        "processing": "處理中..."
      },
      "deleteAccount": {
        "title": "註銷帳號",
        "desc": "永久刪除您的帳號及所有相關資料",
        "button": "註銷帳號",
        "confirm": "此操作不可撤銷，您的所有資料將被永久刪除。",
        "confirmButton": "確認註銷",
        "cancel": "取消"
      }
    },
    "checkout": {
      "points": {
        "title": "積分抵扣",
        "unit": "積分",
        "available": "可用",
        "deduct": "抵扣"
      },
      "coupon": {
        "title": "優惠券",
        "none": "不使用優惠券"
      },
      "summary": {
        "order": "訂單金額",
        "discount": "優惠",
        "total": "實付"
      }
    },
    "profile": {
      "form": {
        "nickname": "暱稱",
        "avatar": "頭像連結",
        "locale": "語言偏好",
        "save": "儲存",
        "saving": "儲存中..."
      }
    },
    "auth": {
      "login": {
        "emailLabel": "電子郵件",
        "passwordLabel": "密碼",
        "submit": "登入",
        "createAccount": "建立帳號",
        "forgotPassword": "忘記密碼？",
        "orDivider": "或"
      },
      "register": {
        "emailLabel": "電子郵件",
        "passwordLabel": "密碼",
        "confirmPasswordLabel": "確認密碼",
        "passwordHint": "至少 8 個字元，包含字母和數字",
        "submit": "建立帳號",
        "submitting": "建立中...",
        "hasAccount": "已有帳號？立即登入",
        "passwordMismatch": "兩次輸入的密碼不一致"
      },
      "oauth": {
        "continueWith": "透過 {provider} 繼續"
      },
      "verify": {
        "title": "驗證您的電子郵件",
        "description": "我們已向 {email} 發送了驗證碼",
        "digitLabel": "第 {index} 位",
        "resend": "重新傳送驗證碼",
        "resendCountdown": "重新傳送（{countdown}秒）",
        "backToRegister": "返回註冊"
      },
      "forgot": {
        "title": "重設密碼",
        "description": "輸入您的電子郵件，我們將傳送驗證碼給您。",
        "emailLabel": "電子郵件",
        "submit": "傳送驗證碼",
        "backToLogin": "返回登入"
      }
    },
    "error": {
      "network": "網路錯誤，請重試",
      "retry": "重試",
      "retryLabel": "重新載入"
    }
  },
  "sdk": {
    "error": {
      "210900": "參數錯誤",
      "210901": "租戶ID不能為空",
      "210902": "請求頻率超限，請稍後再試",
      "210903": "未授權",
      "210904": "Token 已過期",
      "210905": "Token 無效",
      "210906": "Token 重新整理失敗",
      "210907": "平台 Token 交換失敗",
      "210908": "Refresh Token 無效",
      "210909": "Refresh Token 已過期",
      "210911": "會員不存在",
      "210912": "會員等級資訊不存在",
      "210920": "該信箱已註冊",
      "210921": "密碼強度不足：至少8位，包含字母和數字",
      "210922": "驗證碼傳送過於頻繁，請稍後再試",
      "210923": "驗證碼錯誤或已過期",
      "210924": "註冊資訊已過期，請重新註冊",
      "210925": "信箱或密碼錯誤",
      "210926": "信箱未驗證，請先完成驗證",
      "210927": "OAuth 認證失敗",
      "210928": "OAuth state 無效或已過期",
      "210929": "不支援的登入方式",
      "210930": "使用者建立失敗",
      "210931": "折扣計算失敗",
      "210951": "積分餘額查詢失敗",
      "210952": "積分流水查詢失敗",
      "210953": "積分獲取失敗",
      "210954": "積分啟用失敗",
      "210955": "積分消耗失敗",
      "210956": "積分餘額不足",
      "210957": "積分記錄不存在",
      "210958": "積分狀態不允許該操作",
      "210971": "優惠券已搶完",
      "210972": "已領過該券",
      "210981": "訊息佇列寫入失敗",
      "210982": "內部服務同步失敗",
      "210983": "兌換商品不存在",
      "210984": "兌換失敗",
      "210985": "邀請碼不存在",
      "210986": "綁定邀請人失敗",
      "210987": "邀請人不存在",
      "210988": "不能邀請自己",
      "210989": "優惠券領取失敗",
      "210990": "今日已簽到",
      "210991": "簽到失敗",
      "211001": "回呼簽章驗證失敗",
      "211002": "不支援的回呼平台",
      "211003": "回呼請求重複",
      "211004": "Webhook Secret 未設定",
      "211005": "回呼時間戳逾時",
      "211900": "操作失敗，請稍後重試",
      "211901": "認證失敗",
      "211902": "該帳號未綁定管理權限",
      "211903": "無權限操作",
      "211904": "設定項不存在",
      "211905": "設定作用域非法",
      "211906": "角色不存在",
      "211907": "系統角色不可刪除",
      "211908": "管理員無權存取該租戶",
      "211909": "參數校驗失敗",
      "211910": "資源不存在",
      "211911": "找不到對應的會員資訊",
      "211912": "身份關聯衝突，請聯絡客服",
      "211913": "影子帳號啟用失敗",
      "211914": "審核記錄不存在",
      "211915": "審核記錄狀態非待審核",
      "211916": "OneID 不存在",
      "211917": "OneID 解除關聯失敗",
      "211931": "等級設定不存在",
      "211932": "等級有關聯會員，禁止刪除",
      "211933": "升級條件校驗失敗",
      "211934": "等級序列必須連續",
      "211951": "積分狀態遷移非法",
      "211952": "積分餘額不足",
      "211953": "積分記錄不存在",
      "211954": "積分流水重複入帳",
      "211955": "積分消耗數量無效",
      "211956": "積分抵扣超過最大比例",
      "211957": "積分未達最低消耗門檻",
      "211958": "積分獲取規則未設定",
      "211959": "積分啟用失敗：狀態非待確認",
      "211960": "積分流水查詢越權",
      "211961": "積分過期已處理",
      "211962": "成長值規則未設定",
      "211971": "優惠券範本不存在",
      "211972": "優惠券範本狀態非可發放",
      "211973": "優惠券超出每使用者領取上限",
      "211974": "優惠券超出總發放量",
      "211975": "優惠券核銷狀態非可用",
      "211976": "優惠券已過期",
      "211977": "優惠券範本已發放，禁止刪除",
      "211981": "推送任務不存在",
      "211982": "推送任務狀態不允許編輯",
      "211983": "推送任務狀態不允許取消",
      "211984": "推送範本不存在",
      "211985": "推送目標人群為空",
      "211991": "服務忙碌，請稍後重試",
      "211992": "訊息發佈失敗",
      "211993": "訊息已進入死信佇列",
      "network": "網路異常，請檢查連線後重試",
      "timeout": "請求逾時，請稍後重試",
      "aborted": "請求已被取消",
      "parse": "資料解析異常",
      "unauthorized": "請先登入",
      "config": "SDK 初始化參數錯誤",
      "unknown": "發生未知錯誤，請稍後重試"
    }
  },
  "exchange": {
    "store": {
      "title": "積分商城",
      "myOrders": "我的兌換",
      "empty": "暫無可兌換商品",
      "points": "積分",
      "stock": "庫存",
      "back": "返回",
      "redeem": "立即兌換",
      "soldOut": "已兌完",
      "noOrders": "暫無兌換記錄",
      "status": {
        "pending": "待發貨",
        "completed": "已完成",
        "cancelled": "已取消"
      }
    }
  },
  "message": {
    "center": {
      "title": "訊息中心",
      "empty": "暫無訊息"
    },
    "type": {
      "system": "系統通知",
      "marketing": "行銷活動",
      "transaction": "交易通知",
      "activity": "活動通知"
    }
  }
}
